var WAAClock = require('./lib/WAAClock')

module.exports = WAAClock
if (typeof window !== 'undefined') window.WAAClock = WAAClock



//////////////////
// WEBPACK FOOTER
// ./~/waaclock/index.js
// module id = 42
// module chunks = 0